import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  currentLive: null,
  loading: false,
  error: null,
};

const liveSessionSlice = createSlice({
  name: "liveSession",
  initialState,
  reducers: {
    currentLive: (state, action) => {
      state.currentLive = action.payload;
    },
    setChatEnabledState: (state, action) => {
      state.currentLive.room.chat_enabled = action.payload;
    },
    clearLive: (state) => {
      state.currentLive = initialState.currentLive;
    },
  },
});

export const { currentLive, setChatEnabledState, clearLive } =
  liveSessionSlice.actions;

export const selectCurrentLive = (state) => state.liveSession.currentLive;

export default liveSessionSlice.reducer;
